export async function fetchAndProcessData(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();

        let tempC = {};
        let index = 0;
        data.forEach((row) => {

            if (row.type === "Competenties") {
                row.sub = [];
                row.score = 0;
                row.index = index;
                index++;
                row["taxonomies"].forEach((sub) => {
                    row["sub"].push(sub.id);
                });
                tempC[row.id] = row;
            }
        });

        let temp = {};
        data.forEach((row) => {
            if (row.type === "Skills") {
                let parent = 0;
                for (const key in tempC) {
                    if (tempC[key].sub.includes(row.id)) {
                        parent = tempC[key].id;
                    }
                }
                row.score = 0;
                row.parent = parent;
                temp[row.id] = row;
            }
        });

        return { categories: tempC, questions: temp };
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
    }
}

export async function fetchAndProcessAndSlug(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();



        let temp = {};
        data.forEach((row) => {
            temp[row.slug] = row;
        });


        return { data: temp };
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
    }
}
